// Screen `jobs` — design/screens/JobsEvents.dc.html — owner: S11. `?scope=installation`: the installation's
// view (instance operators).
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { JobsPage } from '../../../features/ops/JobsPage';

const Search = z.object({ scope: z.enum(['installation']).optional().catch(undefined) });

export const Route = createFileRoute('/_settings/settings/jobs')({
  validateSearch: (s) => Search.parse(s),
  component: JobsRoute,
});

function JobsRoute() {
  const { scope } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <JobsPage
      scope={scope ?? 'workspace'}
      onScope={(next) =>
        void navigate({ search: next === 'installation' ? { scope: next } : {}, replace: true })
      }
    />
  );
}
